/**
 * Module Dependencies
 */

import { get } from 'safe-prop'
import is_num from 'is-number'

/**
 * Sort an array of object based on a key
 * in a certain direction
 */

export default function sorter (key, direction = 1) {
  direction = normalize(direction)

  return (a, b) => {
    let result = 0
    if (get(a, key) < get(b, key)) {
      result = -1
    } else if (get(a, key) > get(b, key)) {
      result = 1
    }
    return result * direction
  }
}

export function normalize (direction) {
  if (!is_num(direction)) {
    direction = direction === 'desc' ? -1 : 1
  }
  return direction
}
